import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: `${process.env.FIREBASE_APIKEY}`,
  authDomain: "reasons-to-act-challenge.firebaseapp.com",
  projectId: "reasons-to-act-challenge",
  storageBucket: "reasons-to-act-challenge.firebasestorage.app",
  messagingSenderId: `${process.env.FIREBASE_MESSAGING_SENDER_ID}`,
  appId: `${process.env.FIREBASE_APP_ID}`
};

// DEV
// const firebaseConfig = {
//   apiKey: `${process.env.FIREBASE_APIKEY}`,
//   authDomain: "glacier-challenge.firebaseapp.com",
//   projectId: "glacier-challenge",
//   storageBucket: "glacier-challenge.firebasestorage.app",
//   messagingSenderId: `${process.env.FIREBASE_MESSAGING_SENDER_ID}`,
//   appId: `${process.env.FIREBASE_APP_ID}`
// };

  const app = initializeApp(firebaseConfig);
  export const db = getFirestore(app);
  export const storage = getStorage(app);
